import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ZapIcon, PlayCircleIcon, BookOpenIcon, ShieldAlertIcon } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    icon: <ZapIcon className="w-8 h-8 text-amber" data-id="element-33" />,
    title: 'The "Quick" Walkthrough',
    description: 'You move your thumbs at 100mph while they watch, but they forget the steps the second you leave.'
  }, {
    icon: <PlayCircleIcon className="w-8 h-8 text-amber" data-id="element-34" />,
    title: 'YouTube Tutorials',
    description: 'These are made for teenagers and move far too fast for a beginner to follow.'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-amber" data-id="element-35" />,
    title: 'Traditional Manuals',
    description: 'Written by engineers in jargon-filled "computer-speak" that feels like a foreign language.'
  }, {
    icon: <ShieldAlertIcon className="w-8 h-8 text-amber" data-id="element-36" />,
    title: 'The Fear Factor',
    description: 'Without a physical guide to hold, they remain afraid of "breaking" their expensive device.'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-37">
      <div className="max-w-5xl mx-auto" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-40">
            Why What You've Tried Didn't Work
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-41">
          {solutions.map((solution, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-42">
              <div className="bg-cream rounded-2xl p-8 h-full border border-warmGray hover:shadow-warm transition-shadow duration-300" data-id="element-43">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm mb-6" data-id="element-44">
                  {solution.icon}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-45">{solution.title}</h3>
                <p className="text-charcoal/80 leading-relaxed text-lg" data-id="element-46">
                  {solution.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}